import { LotQuery } from 'components/pages/LotBasePage/types/lotQuery'
import React from 'react'
import CtaSection from 'components/pages/LotPage/CtaSection'
import AppAds from 'components/AppAds'
import LotSection from 'components/pages/LotPage/LotSection'
import HeroSection from 'components/HeroSection'
import LotReferralSection from 'components/LotReferralSection'
import FallbackImage from 'images/truck-crowd.jpg'
import { useRouter } from 'next/router'
import Notice from 'components/pages/LotBasePage/Notice'
import LinksSection from 'components/HeroSection/LinksSection'
import Locations from 'components/pages/LotPage/Locations'
import sortBy from 'lodash/sortBy'

type Props = {
  lotGroup: NonNullable<LotQuery['lotGroup']>
  globalConfig: NonNullable<LotQuery['globalConfig']>
}

const LotGroupPage = ({ lotGroup, globalConfig }: Props) => {
  const router = useRouter()
  const hideMarketing =
    router.asPath.includes('boeing') || router.asPath.includes('homedepot')
  const firstLot =
    lotGroup.lots && sortBy(lotGroup.lots, (l) => l.lotGroupPosition)[0]
  const heroLinks = {
    twitter: firstLot && firstLot.twitter,
    facebook: firstLot && firstLot.facebook,
    instagram: firstLot && firstLot.instagram,
    website: firstLot && firstLot.website
  }
  return (
    <div className="w-full bg-white">
      <HeroSection
        content={
          <LotSection
            address={null}
            heroLinks={heroLinks}
            name={lotGroup.name || lotGroup.address || ''}
            subscriptionLotId={null}
          />
        }
        imageContent={
          lotGroup.notice.present ? (
            <Notice
              className="pr-8 sm:pr-0"
              notice={lotGroup.notice}
              variant="transparent"
            />
          ) : null
        }
        imageSrc={
          lotGroup.image?.present ? lotGroup.image?.original! : FallbackImage
        }
        links={<LinksSection socialLinks={heroLinks} />}
        size="tiny"
      />
      <Locations
        locationSchedule={lotGroup.locationSchedule}
        lotGroup={lotGroup}
        schedulePath={lotGroup.schedulePath}
      />
      {!hideMarketing && <CtaSection />}
      <AppAds />
      <LotReferralSection
        lotEnabled={firstLot?.referralEnabled ?? false}
        lotId={firstLot?.id ?? 0}
        lotName={lotGroup.name!}
        lotUrl={lotGroup.lotGroupUrl}
        referralBonus={globalConfig.bonusForReferral}
      />
    </div>
  )
}

export default LotGroupPage
